import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})

export class HeaderService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService, private loginService: LoginService) { }

  /**
   * Description: Método que llama el servicio web que obtiene los items de menú
   * Autor: Diego Diaz
   * @param N/A
   * @return Listado de ítem de menú
   */
  getMenuList(category) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_MENU_LIST,category);
  }

}
